export const EVENT_KEYS = {
	getEvents: ["events"],
	getEventsMonthYear: (placeId: string, monthYear: string) => [
		...EVENT_KEYS.getEvents,
		placeId,
		monthYear,
	],
} as const;
